/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Prev_SectionInputs */

const en_playbar_prev_section = /** @type {(inputs: Playbar_Prev_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back 30s`)
};

const es_playbar_prev_section = /** @type {(inputs: Playbar_Prev_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retroceder 30 s`)
};

/**
* | output |
* | --- |
* | "Back 30s" |
*
* @param {Playbar_Prev_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_prev_section = /** @type {((inputs?: Playbar_Prev_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Prev_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_prev_section(inputs)
	return en_playbar_prev_section(inputs)
});